import React, { Component } from 'react'

export default class Browse extends Component {
  render() {
    return (
      <div>
        Browse
      </div>
    )
  }
}
